import { useGetFaireAcademyPageState } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import { getSettingOwFGrantMoney } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingOwFGrantMoney";
import {
  FAInnerWrapperColumn,
  FAOuterWrapper,
} from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/styles";
import { OWF_SECTION_NAME } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/types";
import { OwFGrantCtas } from "@faire/deprecated-retailer-visitor-shared/views/owf-small-business-grant/application-page/types";
import { trackOpenWithFaireOwfGrantPageCtaClicksClick } from "@faire/web-api--source/events/openWithFaire/click/owfGrantPageCtaClicks";
import { trackOpenWithFaireFaireAcademySectionView } from "@faire/web-api--source/events/openWithFaire/view/faireAcademySection";
import { route as smallBusinessGrantRoute } from "@faire/web-api--source/routes/www/small-business-grant";
import { route as smallBusinessGrantApplyRoute } from "@faire/web-api--source/routes/www/small-business-grant/apply";
import { useFormatMoney } from "@faire/web/common/money";
import { Button } from "@faire/web/slate/Button/Button";
import { Column } from "@faire/web/slate/Layout/Column/Column";
import { Flex } from "@faire/web/slate/Layout/Flex";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { SlideIn } from "@faire/web/ui/SlideIn/SlideIn";
import React from "react";
import { styled } from "styled-components";

export const OwfGrantUpsell: React.FC = () => {
  const { pageState } = useGetFaireAcademyPageState();
  const ref = useDoActionWhenVisible(() =>
    trackOpenWithFaireFaireAcademySectionView(
      pageState,
      OWF_SECTION_NAME.OWF_GRANT_UPSELL
    )
  );

  return (
    <FAOuterWrapper ref={ref}>
      <FAInnerWrapperColumn>
        <OwfGrantUpsellContent />
      </FAInnerWrapperColumn>
    </FAOuterWrapper>
  );
};

const OwfGrantUpsellContent: React.FC = () => {
  // TODO: (hamidrezahanafi) problem with react compiler and id generation
  "use no memo";
  const { formatMoney } = useFormatMoney();
  const owfGrantMoney = getSettingOwFGrantMoney();

  const imageSrc =
    "https://cdn.faire.com/fastly/1840134e159680ee0eb6e9a144650a410b39e4958e49c628dd6d3b0efc61a94f.png";

  return (
    <ResponsiveRowOrColumn>
      <SlideIn offset="50px">
        <RelativeDiv>
          <StyledImage src={imageSrc} alt="" />
        </RelativeDiv>
      </SlideIn>
      <Spacer size={{ mobileAndAbove: "4x", desktopAndAbove: "8x" }} />
      <Column justify="center">
        <SlideIn offset="50px">
          <Typography
            variant={{
              mobileAndAbove: "displaySSerifRegular",
              desktopAndAbove: "displayMSerifRegular",
            }}
          >
            <StrictLocalMsg
              id="8m3RyT"
              defaultMessage="Apply for a {grantMoney} grant to stock your new store"
              description={{
                text: "Description of what Open with Faire payment terms increase helps with",
                img: "https://cdn.faire.com/fastly/1f550fc38a02708cbd7f800fbc489f87ca5a913d90e16227e111a63b847b0367.png",
              }}
              values={{
                grantMoney: formatMoney({
                  money: owfGrantMoney,
                  omitCentsIfZero: true,
                }),
              }}
            />
          </Typography>
        </SlideIn>
        <Spacer height={{ mobileAndAbove: "2x", desktopAndAbove: "3x" }} />
        <SlideIn offset="70px">
          <Typography
            variant={{
              mobileAndAbove: "paragraphSansRegular",
              desktopAndAbove: "subheadingSansRegular",
            }}
          >
            <StrictLocalMsg
              id="cgg2Vj"
              defaultMessage="Our small business grant program gives select new stores {grantMoney} to use on Faire to stock their shelves with amazing products. It’s our way of helping you kickstart your dream shop."
              description={{
                text: "Description of what Open with Faire payment terms increase helps with",
                img: "https://cdn.faire.com/fastly/1f550fc38a02708cbd7f800fbc489f87ca5a913d90e16227e111a63b847b0367.png",
              }}
              values={{
                grantMoney: formatMoney({
                  money: owfGrantMoney,
                  omitCentsIfZero: true,
                }),
              }}
            />
          </Typography>
        </SlideIn>
        <SlideIn offset="70px">
          <Spacer height={{ mobileAndAbove: "2x", desktopAndAbove: "3x" }} />
          <ResponsiveRowOrColumn>
            <Button
              variant="secondary"
              linkTo={smallBusinessGrantApplyRoute}
              onClick={() =>
                trackOpenWithFaireOwfGrantPageCtaClicksClick(
                  OwFGrantCtas.APPLY_NOW,
                  OWF_SECTION_NAME.OWF_GRANT_UPSELL
                )
              }
            >
              <StrictLocalMsg
                id="WUL9Nr"
                defaultMessage="Apply now"
                description={{
                  text: "Button CTA for a retailer to apply for Open with Faire Grants",
                  img: "https://cdn.faire.com/fastly/1f550fc38a02708cbd7f800fbc489f87ca5a913d90e16227e111a63b847b0367.png",
                }}
              />
            </Button>
            <Spacer size="2x" />
            <Button variant="tertiary" linkTo={smallBusinessGrantRoute}>
              <StrictLocalMsg
                id="a/XHiA"
                defaultMessage="Learn more"
                description={{
                  text: "Button CTA for a retailer to learn more about Open with Faire Grants",
                  img: "https://cdn.faire.com/fastly/1f550fc38a02708cbd7f800fbc489f87ca5a913d90e16227e111a63b847b0367.png",
                }}
              />
            </Button>
          </ResponsiveRowOrColumn>
        </SlideIn>
      </Column>
    </ResponsiveRowOrColumn>
  );
};

const ResponsiveRowOrColumn = styled(Flex).attrs({
  direction: { mobileAndAbove: "column", tabletAndAbove: "row" },
})``;

const RelativeDiv = styled.div`
  position: relative;
`;

const StyledImage = styled.img`
  width: 455px;
  height: 455px;
  max-width: max-content;

  ${responsiveMediaQueries.tablet} {
    width: 300px;
    height: 300px;
  }
  ${responsiveMediaQueries.mobile} {
    width: 100%;
    height: 100%;
  }
`;
